export default __webpack_public_path__ + "static/media/Hinchliffe_Rendering_BallParkDigest1.74bcaabe.jpeg";